// Change main image in product page when changing variants
(function() {
  function variantChange() {
    document.querySelector('[name="id"]').addEventListener('change', function(e) {
      setTimeout(function() {
        var $select = document.querySelector('[name="id"]');
        document.querySelector('.product-title-block').innerText = $select.querySelector('option:checked').dataset.title;

        // Call the swapVariantImage function to update the image and sizes attribute
        swapVariantImage();
      }, 0);
    });
  }
  
  function swapVariantImage() {
    // Retrieve the new sizes value based on the selected variant 
    var newSizes = "100vw"; 
    
    // Update the image sizes attribute
    var imageElement = document.querySelector('.main-product-image .responsive-image');
    imageElement.setAttribute('sizes', newSizes);
  }

  window.onload = function() {
    if (document.querySelector('[name="id"]')) {
      variantChange();
    }
  };
})();

if (document.querySelector('.full-screenable-video')) {
  document.addEventListener('DOMContentLoaded', function () {
    var videoElement = document.querySelector('.full-screenable-video video');
    var videoSrc = videoElement.querySelector('source').getAttribute('src');
    var videoPoster = videoElement.getAttribute('poster');
    var overlayVideo;

    // Remove controls attribute to hide video controls
    videoElement.removeAttribute('controls');

    // Add play button overlay
    var playButton = document.createElement('div');
    playButton.classList.add('play-button');
    playButton.innerHTML = '<svg role="presentation" focusable="false"><use xlink:href="#plyr-play-large"></use></svg>';
    videoElement.parentNode.insertBefore(playButton, videoElement);

    // Add overlay container
    var overlayContainer = document.createElement('div');
    overlayContainer.classList.add('video-overlay-container');
    document.body.appendChild(overlayContainer);

    // Function to open the overlay and play the video
    function openVideoOverlay() {
      overlayContainer.classList.add('show');
      var closeButton = document.createElement('button');
      closeButton.classList.add('text-primary-text', 'fixed', 'top-0', 'right-0', 'block', 'w-6', 'h-6', 'mt-3', 'mr-3');
      closeButton.title = 'Close (Esc)';
      closeButton.innerHTML = '<span class="visually-hidden">Close</span><svg aria-hidden="true" focusable="false" role="presentation" class="icon fill-current icon-close" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M18.364 4.222l1.414 1.414L13.414 12l6.364 6.364-1.414 1.414L12 13.414l-6.364 6.364-1.414-1.414L10.586 12 4.222 5.636l1.414-1.414L12 10.586z"></path></svg>';
      overlayContainer.appendChild(closeButton);
      overlayVideo = document.createElement('div');
      overlayVideo.classList.add('video-overlay');
      overlayVideo.innerHTML = '<video controls playsinline preload="metadata" aria-label="' + videoElement.getAttribute('aria-label') + '" poster="' + videoPoster + '"><source src="' + videoSrc + '" type="video/mp4"></video>';
      overlayContainer.appendChild(overlayVideo);
      overlayVideo.querySelector('video').play();
    }

    // Function to close the overlay and pause the video
    function closeVideoOverlay() {
      overlayContainer.classList.remove('show');
      overlayContainer.innerHTML = '';
      overlayVideo.querySelector('video').pause();
    }

    // Event listener for video element click
    videoElement.addEventListener('click', function () {
      openVideoOverlay();
    });

    // Event listener for closing the overlay
    overlayContainer.addEventListener('click', function (event) {
      if (!event.target.closest('.video-overlay')) {
        closeVideoOverlay();
      }
    });
  });
}

